import React from 'react';
import './FAQ.css';

const FAQ = () => {
  return (
    <section className="faq" id="faq">
      <h2 className="faq_title">Frequently Asked Questions</h2>

      <div className="faq_list">

        <div className="faq_item">
          <h3 className="faq_question">Can I control my devices remotely?</h3>
          <p className="faq_answer">
            Yes, you can monitor and control all connected devices from anywhere using your phone.
          </p>
        </div>

        <div className="faq_item">
          <h3 className="faq_question">Is my data secure?</h3>
          <p className="faq_answer">
            All data is encrypted, stored securely, and never shared without your consent.
          </p>
        </div>

        <div className="faq_item">
          <h3 className="faq_question">Does HomeApp support automation?</h3>
          <p className="faq_answer">
            Yes, you can create schedules, triggers, and automation routines for your devices.
          </p>
        </div>

        <div className="faq_item">
          <h3 className="faq_question">Which platforms is HomeApp available on?</h3>
          <p className="faq_answer">
            iOS and Android for full management of your smart home devices.
          </p>
        </div>

        <div className="faq_item">
          <h3 className="faq_question">Can multiple users manage the same home?</h3>
          <p className="faq_answer">
            Yes, you can invite family members or roommates to control devices securely.
          </p>
        </div>

      </div>
    </section>
  );
};

export default FAQ;
